import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import storeLoader from 'app/stores/storeLoader';
import CreditUtilization from 'app/views/synthetics/components/dashboard/CreditUtilization';
import WidgetFrame from '../WidgetFrame';

@storeLoader('$syn.tests', '$syn.agents')
@inject('$syn')
@observer
class CreditUtilizationWidget extends Component {
  constructor(props) {
    super(props);

    const { $syn } = props;

    $syn.plan.loadUsageData();
  }

  render() {
    const { $syn, canCustomize, onRemove } = this.props;

    return (
      <WidgetFrame canCustomize={canCustomize} onRemove={onRemove} title="Credit Utilization">
        <CreditUtilization loading={$syn.tests.loading || $syn.plan.loading || $syn.plan.loadingUsage} isWidgetView />
      </WidgetFrame>
    );
  }
}

export default CreditUtilizationWidget;
